import React from "react";
import './style.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {  faLocationDot, faPhone } from '@fortawesome/free-solid-svg-icons';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons';
import { faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons';
import {Link} from 'react-router-dom';
import companyLogo from '../src/assets/TripandDrop_whitelogo.png' ;


function Footer() {
    return(
<>
<footer class='footer-portion'>
   

   <div className="footer-upper">

   <div className="footer-logo">
   <img src={companyLogo} alt='Logo' className='logo'/>
   <p>Your Trusted Partner for Visa, Flights & Tour Packages</p>
   {/* <p>Mohindro Arora and Co. is a renowned chartered accountancy firm located in New Delhi. With a legacy of excellence and a commitment to integrity</p> */}
   </div>

 
   <div className="footer-link">
    <h1>Useful Links</h1>
    <ul class='useful-link'>
      <li><Link to="/" className="footers-link" >Home</Link></li>
      <li><Link to="/about" className="footers-link" >About Us</Link></li>
      <li><Link to="/services" className="footers-link" >Services</Link></li>
      {/* <li><Link to="/client" className="footers-link" >Clients</Link></li> */}
      {/* <li><Link to="/team" className="footers-link" >Team</Link></li> */}
      {/* <li>Blog</li> */}
      <li><Link to="/contactus" className="footers-link" >Contact Us</Link></li>   
    </ul>
   </div>

   {/* <div>
    <h1>Our Services</h1>
    <ul class='useful-link'>
      <li>Accounting</li>
      <li>Auditing and Assurance</li>
      <li>Income Tax</li>
      <li>Startup Services</li>
      <li>Gst</li>
      <li>Merger and Acquisitions</li>
      <li>Finance</li>   
    </ul>
   </div> */}

   <div className="footer-link">
    <h1>Business Hours</h1>
    <ul class='useful-link'>
      <li>Monday to Saturday</li>
      <li>9:00 AM to 6:00 PM</li>
    </ul>
   </div>
  

   <div className="footer-link">
    <h1>Contact Us</h1>
    <ul class='useful-link'>
  <div>
    <FontAwesomeIcon icon={faLocationDot} class='headericons'  style={{height:'30px',width:'30px', marginTop:'2px'}} />
    
  
    <li className='address'>H-35 Sant Nagar Extension , Tilak Nagar Delhi-110018</li>
      </div>
      <div><FontAwesomeIcon icon={faPhone} class='headericons'  style={{height:'28px',width:'28px'}}/><li>+91 9999116868</li></div>
      <div><FontAwesomeIcon icon={faEnvelope} class='headericons'  style={{height:'28px',width:'28px'}}/> <li>tripanddroptravels@gmail.com</li>  </div>   
    </ul>
   </div>

   </div>

   <div className="footer-lower">

   <div class='copyright-section'>
   <p> &copy; 2025 Trip and Drop Travels Pvt. Ltd. All Rights Reserved.</p>
   </div>

   <div className="footer-social">
  <p style={{color:'white'}}>Follow us :</p>
  <a href="https://www.facebook.com/tripanddroptravels" target="_blank" rel="noreferrer" ><FontAwesomeIcon icon={faFacebook} className='footericons' /></a>
  {/* <a href="https://x.com/Mohindraaroraco" target="_blank" rel="noreferrer" ><BsTwitterX class='footericons'/></a> */}
  {/* <a href="https://www.linkedin.com/company/mohindraaroraandco/" target="_blank" rel="noreferrer" ><FaLinkedin class='footericons'/></a> */}
  <a href="https://www.instagram.com/tripanddroptravels/" target="_blank" rel="noreferrer" ><FontAwesomeIcon icon={faInstagram} className='footericons'/></a>
  </div>

  </div>  



  </footer>
</>

    );
}

export default Footer ;